import { ArrowRightIcon } from '@grupoboticario/flora-react-icons';
import { ResponsiveFloraTypography, Text } from 'ui/components/primitives';
import { ProductCard } from '../../Product';
import { QuantitySelector } from '../../QuantitySelector';
import Styles from './Combo.components.styles';
import type { ComboCardProps } from './Combo.components.d';

const ComboCard = ({
  available,
  image,
  isDisabled,
  isMobile,
  name,
  onAddCombo,
  onChange,
  price,
  quantity,
  sku,
}: ComboCardProps) => {
  const handleUpdateQuantity = (value: number) => {
    onChange(value);
  };

  const handleAddProduct = () => {
    onAddCombo();
  };

  return (
    <Styles.Combo>
      <Styles.ProductCard
        data-available={available}
        data-radius="rounded"
        data-testid="product-card"
        spacing={isMobile ? 'large' : 'small'}
      >
        <Styles.Container>
          <Styles.Picture
            alt={name}
            opacity={available ? '100' : '25'}
            ratio={isMobile ? 'none' : '4x3'}
            sources={[
              {
                srcSet: `${image}`,
              },
            ]}
            src={image}
          />
          {!available && <ProductCard.UnavailableStripe>Sem estoque</ProductCard.UnavailableStripe>}
          <ProductCard.Code>{sku}</ProductCard.Code>
          <ResponsiveFloraTypography as="h6" fontSize="subtitle" css={{ margin: 0 }}>
            {name}
          </ResponsiveFloraTypography>

          <div>
            <Styles.PriceWrapper>
              <ProductCard.PriceTitle>Pague</ProductCard.PriceTitle>
              <ProductCard.PriceValue data-max>{price.price}</ProductCard.PriceValue>
            </Styles.PriceWrapper>
            <Styles.PriceWrapper>
              <ProductCard.PriceTitle>Revenda</ProductCard.PriceTitle>
              <ProductCard.PriceValue>{price.maxPrice}</ProductCard.PriceValue>
            </Styles.PriceWrapper>
            <Styles.PriceWrapper>
              <ProductCard.PriceTitle>Lucre</ProductCard.PriceTitle>
              <ProductCard.PriceValue>{price.profit}</ProductCard.PriceValue>
            </Styles.PriceWrapper>
          </div>

          <Styles.Divider />

          <Text>Quantidade de combo(s) :</Text>
          <QuantitySelector
            disabled={!available}
            min={1}
            onChange={handleUpdateQuantity}
            value={quantity}
          />

          <Styles.Divider />

          <Styles.WrapperButton>
            <Styles.Button disabled={isDisabled} onClick={handleAddProduct} stretch>
              Adicionar ao carrinho <ArrowRightIcon size={12} />
            </Styles.Button>
          </Styles.WrapperButton>
        </Styles.Container>
      </Styles.ProductCard>
    </Styles.Combo>
  );
};

export default ComboCard;
